import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, StateModel } from "@insite/client-framework/Types/ApiModels";

export interface AddressValidationParameter {
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
}

export interface ApiDataValue extends BaseModel {
    input_index: string;
    candidate_index: string;
    delivery_line_1: string;
    delivery_line_2: string | any;
    last_line: string;
    components: Components;
    analysis: Analysis;
}

export interface Components extends BaseModel {
    primary_number: string;
    street_name: string;
    street_suffix: string;
    city_name: string;
    state_abbreviation: string;
    zipcode: string;
    plus4_code: string;
}

export interface Analysis extends BaseModel {
    dpv_match_code: string;
}

const addressValidationUri = "/api/v1/addressValidation";

export async function applyAddressValidation(
    addressValidationParameter: AddressValidationParameter,
): Promise<ServiceResult<ApiDataValue[]>> {
    try {
        const data = await post<AddressValidationParameter, ApiDataValue[]>(
            `${addressValidationUri}`,
            addressValidationParameter,
        );
        return {
            successful: true,
            result: data,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function applyMultipleAddressValidation(addresses: Array<any>): Promise<ServiceResult<Array<any>>> {
    try {
        const data = await post<Array<any>, Array<any>>(`${addressValidationUri}/multipleAddresses`, addresses);
        return {
            successful: true,
            result: data,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
